export const SURVEY_COMPONENT = {
  STEPS: "steps",
  FORM: "form",
};
